/* eslint-disable react-hooks/exhaustive-deps */
import { Modal } from "antd";
import { useSelector } from "react-redux";
import { State } from "../../model/application/state";

export const Logout = () => {
  const { utilityState }: any = useSelector((state) => state);
  const state: State.Config = utilityState;

  return (
    <Modal
      open={state.logoutConfirmation}
      centered
      keyboard
      cancelText={state.cancelText}
      closable={false}
      width={"25rem"}
      okText={state.okText}
      cancelButtonProps={state.cancelButtonProps}
      title={state.title}
      onOk={state.onOk}
      onCancel={state.onCancel}
    >
      {state.message}
    </Modal>
  );
};
